import React from 'react';
import './ProblemStatementSection.css';

const ProblemStatementSection = () => {
    const problems = [
        { icon: "📉", title: "Limited Access to Resources", description: "Students lack access to comprehensive learning materials and tools." },
        { icon: "⏰", title: "Inflexible Schedules", description: "Traditional education systems don't accommodate diverse learning paces." },
        { icon: "💸", title: "High Costs", description: "Education remains expensive, limiting opportunities for many." },
        { icon: "🔍", title: "Lack of Information", description: "Insufficient data and insights hinder effective decision-making." }
    ];

    return (
        <section id="problem" className="problem-statement-section">
            <div className="container">
                <h2 className="section-heading">Problems in Current Education Systems</h2>
                <p className="section-subheading">Addressing the key challenges faced by students and educators today.</p>
                <div className="problems-grid">
                    {problems.map((problem, index) => (
                        <div className="problem-card" key={index}>
                            <div className="problem-icon">{problem.icon}</div>
                            <h3 className="problem-title">{problem.title}</h3>
                            <p className="problem-description">{problem.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProblemStatementSection;